<template lang="pug">
    .panel-page.body-1
        .panel.mx-auto
            h1.mb-3 Agency Selection
            p Multiple agencies were located at that address. Please select one before continuing.
            SingleSelect(
                v-model="selectedAgencyName"
                :entries="agencyNames"
                @clicked="selectAgency")
            .mt-3
                button.btn.btn-light(@click.prevent="$emit('cancel')") Cancel
</template>

<script>
import SingleSelect from '@/components/SingleSelect'
import { loadForm, formItem } from '@/lib/formstore'

export default {
  name: 'RegistrationAgencySelect',
  data() {
    return {
      selectedAgencyName: '',
      agencies: [],
      agencyName: '',
      agencyState: '',
      agencyId: '',
    }
  },
  computed: {
    agencyNames() {
      return this.agencies.map(a => a.name)
    },
  },
  methods: {
    selectAgency() {
      const agency = this.agencies.filter(
        a => a.name === this.selectedAgencyName,
      )
      this.agencyName = agency[0].name
      this.agencyState = agency[0].state
      this.agencyId = agency[0].id
      this.$nextTick(() => this.$emit('nextState'))
    },
  },
  beforeMount() {
    let agencies = formItem('registration', 'agencies')
    if (agencies.length === 1) {
      this.$emit('nextState')
    }
  },
  mounted: loadForm(
    'registration',
    'agencies',
    'agencyName',
    'agencyState',
    'agencyId',
  ),
  components: { SingleSelect },
}
</script>

<style>
</style>